import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import options from './modules/options'
import permission from './modules/permission'
import tags from './modules/tags'
import creative from './creative/index'
import advertiser from './advertiser'
import resource from './resource'
import config from './config'
import demand from './demand'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    options,
    tags,
    creative,
    advertiser,
    resource,
    config,
    demand,
  },
  getters,
})

export default store
